import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import "react-phone-number-input/style.css";
// import SelectBox from "../CustomWidgets/SelectBox";
import { Button, Input, Table, Modal } from "antd";
import "../../styles.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { UpdateRetailerDetails } from "../../API  Functions/ProfileFunctions";
import LoadingSpinner from "../Loading";
import { checkPermission } from "../../Utils/permissionHelper";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import { toast } from "react-toastify";
import { Trash2 } from "lucide-react"; // delete icon
import UpdatedProfile from "../../modals/UpdatedProfile";
import * as Yup from "yup";
import SelectBox, { MultiSelectBox } from "../CustomWidgets/SelectBox";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Select } from "antd";

const { Option } = Select;



const DailySaleEmail = ({
  payload,
  onDataSubmit,
  profiledetail,
  data,
  fetchdetails,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
const [dailySales, setDailySales] = useState({
  send_daily_sales_email: false,
  email_user_ids: [],
});

useEffect(() => {
  if (data?.retailer_details) {
    setDailySales({
      send_daily_sales_email:
        data?.retailer_details?.send_daily_sales_email || false,
      email_user_ids:
        data?.retailer_details?.email_user_list?.map(
          (u) => u.user_id
        ) || [],
    });
  }
}, [data]);

  useEffect(() => {
    getStoreusers();
  }, []);



  const getStoreusers = () => {
    setLoading(true);
    getStoreUsers(user_id)
      .then((res) => {
        if (res?.result[0]?.status_code === 200) {
          const users = res.result[0]?.response?.filter(
            (user) => user.active === true && (user.user_type == "online_sale" || user.user_type == "admin"),
          );
          if (users) setUsers(users);
        }
      }) 
      .finally(() => setLoading(false));
  };

const handleDailySalesToggle = () => {
  setDailySales((prev) => ({
    ...prev,
    send_daily_sales_email: !prev.send_daily_sales_email,
  }));
};


const handleDailySalesUsers = (users) => {
  setDailySales((prev) => ({
    ...prev,
    email_user_ids: users,
  }));
};

const onSubmit = async()=>{
    if(dailySales.send_daily_sales_email && dailySales.email_user_ids?.length < 1){
        toast.error(t("Please enter users"))
        return;
    }
    try{
        setLoading(true);
const finalPayload = {
      user_id: user_id,
  send_daily_sales_email: dailySales.send_daily_sales_email,
  email_user_ids: dailySales.email_user_ids,
};

        const response = await UpdateRetailerDetails(finalPayload);
        if (response?.status === "Update Successfully") {
            onDataSubmit();
         toast.success(t('Updated Successfully'))
        }
    }catch (err){
console.error("submit error", err);
    }finally{
        setLoading(false);

    }

}

  const filteredOptions = users
          .map((item) => ({
            value: item.user_id,
            label: `${item.name} (${item.email ? item.email : item?.phone})`,
          }));
  return (
    <>
      {loading && <LoadingSpinner />}
<div className="bg-white rounded-lg p-5 mt-5 shadow-sm border">
  <h3 className="text-lg font-semibold mb-4">
    {t("Daily Sales Summary Report")}
  </h3>

  {/* Toggle */}
  <div className="flex items-center justify-between mb-4">
    <p className="text-sm font-medium">
      {t("Enable Daily Sales Email")}
    </p>

    <label className="flex cursor-pointer select-none items-center">
      <div className="relative">
        <input
          type="checkbox"
          checked={dailySales.send_daily_sales_email}
          onChange={handleDailySalesToggle}
          className="sr-only"
        />

        <div
          className={`block h-6 w-12 rounded-full ${
            dailySales.send_daily_sales_email
              ? "bg-green-500"
              : "bg-gray-500"
          }`}
        ></div>

        <div
          className={`absolute left-1 top-1 flex h-4 w-5 items-center justify-center rounded-full bg-white transition ${
            dailySales.send_daily_sales_email
              ? "translate-x-full"
              : ""
          }`}
        ></div>
      </div>
    </label>
  </div>

  {/* Multi Select */}
  {dailySales.send_daily_sales_email && (
    <MultiSelectBox
      componentWidth={"flex flex-col w-full"}
      name="daily_sales_users"
      placeholder={t("Select Users")}
      options={filteredOptions}
      value={dailySales.email_user_ids}
      onChange={(event) => {
        handleDailySalesUsers(event.target.value);
      }}
    />
  )}
  
</div>
  <div className="flex justify-end gap-5  mt-8 mb-10 ">
          <button
            // disabled={!isChanged}
            onClick={onSubmit}
            className={`w-[180px] h-[45px] rounded-lg font-semibold bg-primaryBlue text-white
            
            `}
          >
            {t("Update & Save")}
          </button>
        </div>
 </>
  );
};

export default DailySaleEmail;
